export function librarySearchText(parts:readonly (string|null|undefined)[]):string {
 return parts.filter(Boolean).join(" ").normalize("NFD").replace(/[\u0300-\u036f]/g,"")
  .toLocaleLowerCase("pt-PT").replaceAll("²","2").replaceAll("³","3");
}
export function matchesLibrarySearch(index:string,query:string):boolean {
 const terms=librarySearchText([query]).trim().split(/\s+/).filter(Boolean);
 return terms.every(term=>index.includes(term));
}
